import React, { useRef } from 'react';
import { useContext } from 'react';
import { AppContext } from '/@/app/AppContext';
import {Container, Typography} from '@mui/material';

export const TableOfContents = ({sectionElementRefs, closeDrawer}) => {
    const state = useContext(AppContext).labTestsSectionListState;
    const { mainViewportRef } = useContext(AppContext);

    const scrollToSection = (index) => {
        const viewport = mainViewportRef.current;
        const viewportRect = viewport.getBoundingClientRect();
        const elemRect = sectionElementRefs[index].current.getBoundingClientRect();
        const headerHeight = 64;  // FIXME magic number
        const gap = 10;
        const top = elemRect.top - viewportRect.top + viewport.scrollTop - headerHeight - gap;
        mainViewportRef.current.scrollTo({ top: top, behavior: "smooth" });
        closeDrawer();
    }
    return (
        <Container maxWidth="md" sx={{ mt: 2 }}>
            {state.sections.map((section, index) => (
                <Typography
                    key={index}
                    onClick={() => scrollToSection(index)}
                    variant="body1"
                    gutterBottom
                    sx={{
                        cursor: 'pointer',
                        lineHeight: "1",
                        pt: 0.8,
                        pb: 0.8,
                }}
                >{section.section_name || "Начало"}</Typography>
            ))}
        </Container>
    )
}
